import * as React from 'react';
import styled from 'styled-components';

import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import LaerdalLoadingLogo from '../assets/laerdal-loading-logo.svg';
import { COLORS } from '../styles';

const LoadingMain = styled.main`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: ${COLORS.primary_20};
  height: 100%;
`;

const Header = styled.div<LoaderProps>`
  height: 64px;
  background-color: ${COLORS.white};
  border-bottom: 1px solid ${COLORS.neutral_200};
`;

const LogoAndMessage = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  bottom: 36px;
  left: 50%;
  transform: translate(-50%);
  align-items: center;

  span {
    margin-bottom: 40px;
    font-weight: normal;
    font-size: 18px;
    color: ${COLORS.neutral_600};
    width: 320px;
    text-align: center;
  }
`;

const LoadingIndicatorContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

interface LoaderProps {
  optionalMessage?: string;
  includeHeader?: boolean;
}

const LoadingPage: React.FunctionComponent<LoaderProps> = ({ optionalMessage, includeHeader }: LoaderProps) => {
  return (
    <LoadingMain data-testid="TestLoadingMain">
      {includeHeader && <Header />}
      <LoadingIndicatorContainer>
        <LoadingIndicator />
      </LoadingIndicatorContainer>
      <LogoAndMessage data-testid="TestLoadingLogoAndMessage">
        {optionalMessage && <span>{optionalMessage}</span>}
        <LaerdalLoadingLogo />
      </LogoAndMessage>
    </LoadingMain>
  );
};

export default LoadingPage;
